import React from "react";

// components
import {
  Grid,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  IconButton,
} from "@mui/material";

import RemoveIcon from "@mui/icons-material/Delete";

import DatePicker from "../../components/DatePicker";
import PlanItemDishes from "./PlanItemDishes";

const styles = {
  item: {
    marginTop: "24px",
    borderTop: "1px dotted #ccc",
    paddingTop: "24px",
  },
};

const PlanItem = (props) => {
  const { item, onRemove, onSet, dishes, units } = props;

  return (
    <Grid container sx={styles.item} spacing={1}>
      <Grid item md={1} xs={2}>
        <IconButton onClick={() => onRemove(item)} tabIndex={-1}>
          <RemoveIcon />
        </IconButton>
      </Grid>
      <Grid item md={2} xs={4}>
        <DatePicker
          variant="time"
          label="Vreme:"
          time={item.time}
          onChange={(time) => onSet(item, "time", time?.format("HH:mm"))}
        />
      </Grid>
      <Grid item md={2} xs={6}>
        <FormControl fullWidth variant="standard">
          <InputLabel>Obrok:</InputLabel>
          <Select
            value={item.meal}
            onChange={(e) => onSet(item, "meal", e.target.value)}
          >
            <MenuItem value="dorucak">Doručak</MenuItem>
            <MenuItem value="rucak">Ručak</MenuItem>
            <MenuItem value="vecera">Večera</MenuItem>
            <MenuItem value="uzina">Užina</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item md={7} xs={12}>
        <PlanItemDishes
          item={item}
          onSet={onSet}
          dishes={dishes}
          units={units}
        />
      </Grid>
    </Grid>
  );
};

export default PlanItem;
